import { application } from "./application"
import VideoProgressController from "./video_progress_controller"
import NestedFormController from "./nested_form_controller"
import AdminNavigationController from "./admin_navigation_controller"
application.register("video-progress", VideoProgressController)
application.register("nested-form", NestedFormController)
application.register("admin-navigation", AdminNavigationController)
